// Il cookie otello_d_session_info viaggia su OGNI richiesta verso il pannello.
// Prima conteneva tutti gli header della risposta di login (CSP, date, cf-ray,
// x-request-id...): ~1,9 KB di cui servono ~0,2. Davanti a core, nginx 1.18 in
// HTTP/2 chiude la connessione quando l'header Cookie supera ~4 KB e Cloudflare
// mostra il 520 su tutto il pannello. Si salvano solo gli header di
// devise_token_auth che il pannello rimanda al server.
export const AUTH_SESSION_COOKIE_KEYS = [
  'access-token',
  'token-type',
  'client',
  'expiry',
  'uid',
];

export const pickAuthSessionData = (headers = {}) =>
  AUTH_SESSION_COOKIE_KEYS.reduce((data, key) => {
    if (headers?.[key] !== undefined && headers?.[key] !== null) {
      data[key] = headers[key];
    }
    return data;
  }, {});

// Cookie scritti prima di questa modifica: si riscrivono una volta, ridotti.
export const hasExtraAuthSessionKeys = (data = {}) =>
  Object.keys(data || {}).some(
    (key) => !AUTH_SESSION_COOKIE_KEYS.includes(key)
  );
